var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg44AvatarUserInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430 430",
    style: {
      enableBackground: "new 0 0 430 430"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.5646,
    y1: 91.5826,
    x2: 338.4487,
    y2: 338.4668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cb5eee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4be1ec"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,335.3c29.8-31.3,48.2-73.7,48.2-120.3c0-96.3-78.3-174.6-174.6-174.6S40.4,118.7,40.4,215 c0,46.2,18,88.2,47.4,119.5c0.4,0.6,0.9,1.1,1.4,1.5c31.8,33,76.4,53.6,125.8,53.6c49,0,93.3-20.3,125.1-52.9 C340.6,336.4,341.1,335.9,341.5,335.3z M215,52.4c89.7,0,162.6,73,162.6,162.6c0,38.3-13.3,73.6-35.6,101.4 c-5.1-41.2-40.3-73.3-82.9-73.3h-88.7c-42.4,0-77.6,31.8-82.8,72.9c-22.1-27.8-35.3-62.9-35.3-101C52.4,125.3,125.3,52.4,215,52.4z  M215,377.6c-45.5,0-86.6-18.7-116.1-48.9l0.1-1.8c0-0.1,0-0.1,0-0.2c0-39.4,32.1-71.5,71.5-71.5h88.7c39.4,0,71.5,32,71.5,71.5 l-0.1,2.7C301.1,359.1,260.2,377.6,215,377.6z M214.8,224.3c34.3,0,62.1-27.9,62.1-62.1c0-14.6-5.2-28.8-14.5-39.9 c-11.8-14.1-29.2-22.2-47.6-22.2c-34.3,0-62.1,27.9-62.1,62.1C152.7,196.4,180.5,224.3,214.8,224.3z M214.8,112 c14.8,0,28.8,6.5,38.4,17.9c0,0,0,0,0,0c7.6,9,11.7,20.4,11.7,32.2c0,27.6-22.5,50.1-50.1,50.1s-50.1-22.5-50.1-50.1 S187.2,112,214.8,112z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg44AvatarUserInCircle);
export default __webpack_public_path__ + "static/media/44-avatar-user-in-circle.fd22f6ae44a8a027a63c7d236af2540f.svg";
export { ForwardRef as ReactComponent };